import { createPortal } from "react-dom";

export default function PortalModal({ children }) {
  if (typeof document === "undefined") return null;
  const root = document.getElementById("modal-root");
  return createPortal(children, root);
}
